export default {
  maxToasts: 3,
  newestOnTop: true,
  // transition: "Vue-Toastification__fade",
};